import { CardBackground, Typography } from "@hellocarbo/lasagne";
import { Recycle, RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";

import { AdditionalModule } from "@/components/Shared";
import useOutboundQueryParams from "@/hooks/useOutboundQueryParams";

function AdditionalModules() {
  const { t } = useTranslation("simulation");
  const outboundQueryParams = useOutboundQueryParams("acv");

  return (
    <CardBackground>
      <Typography as="h2" step="1" weight="bold" className="mb-xs">
        {t("simulation:additionalModules")}
      </Typography>
      <div className="gap-sm flex flex-col xl:grid xl:grid-cols-2">
        <AdditionalModule
          Icon={Recycle}
          title={t("simulation:carboProduct.title")}
          text={t("simulation:carboProduct.text")}
          segmentEventName="option_demo_product"
          ctaText={t("common:learnMore")}
          ctaHref="/lca"
          isInternal={true}
        />
        <AdditionalModule
          Icon={RefreshCw}
          title={t("simulation:carboService.title")}
          text={t("simulation:carboService.text")}
          segmentEventName="option_demo_service"
          ctaText={t("common:bookADemo")}
          ctaHref={`https://meetings-eu1.hubspot.com/emmanuelle-vignial/demo-acv${outboundQueryParams}`}
        />
      </div>
    </CardBackground>
  );
}

export default AdditionalModules;
